<script setup>
  import MDC from '~/components/mdc/Mdc.vue'

  const { locale } = useI18n()

  defineProps({
    title: {
      type: String,
      default: null
    },
    date: {
      type: Object,
      default: () => ({})
    },
    tags: {
      type: Array,
      default: () => []
    },
    htmlContent: {
      type: Array,
      default: () => []
    },
    markdownContent: {
      type: String,
      default: null
    }
  })
</script>

<template>
  <div class="p-4 lg:p-8 bg-white border border-slate-200 rounded-lg shadow-xs">
    <h1 v-if="title" class="mb-4 text-balance text-3xl sm:text-5xl text-slate-600 font-semibold tracking-tight">
      {{ title }}
    </h1>
    <div v-if="$slots['after-title']" class="mb-16">
      <slot name="after-title" />
    </div>
    <div v-else-if="title" class="mb-12"></div>
    <div
      :class="[
        'mx-auto max-w-none prose lg:prose-xl prose-slate prose-a:text-sky-600 prose-a:hover:text-sky-500',
        !title && 'prose-h2:first:mt-0'
      ]"
    >
      <div v-if="date.value || tags?.length" class="not-prose flex items-center justify-between">
        <div v-if="date.value" class="flex items-center gap-2 text-xs text-slate-500">
          <font-awesome class="fa-fw" :icon="['fas', 'clock']" />
          <time :datetime="$dayjs(date.value)">
            <span v-if="date.relative">{{ $dayjs(date.value).local(locale).fromNow() }}</span>
            <span v-else>{{ $dayjs(date.value).locale(locale).format('LL') }}</span>
          </time>
        </div>
        <div v-if="tags?.length" class="flex items-center gap-2">
          <CommonBadge
            v-for="tag in tags"
            :key="tag.label"
            :color="tag.color || 'secondary'"
            :interactive="!!tag.callback"
            class="z-10"
            @click="tag.callback"
          >
            {{ tag.label }}
          </CommonBadge>
        </div>
      </div>
      <slot name="content">
        <!-- eslint-disable-next-line vue/no-v-html -->
        <div v-if="htmlContent" v-html="htmlContent"></div>
        <MDC v-else :value="markdownContent" />
      </slot>
    </div>
  </div>
</template>
